import { render } from "./ProssingFour.vue?vue&type=template&id=816704ec&scoped=true"
import script from "./ProssingFour.vue?vue&type=script&lang=js"
export * from "./ProssingFour.vue?vue&type=script&lang=js"

import "./ProssingFour.vue?vue&type=style&index=0&id=816704ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-816704ec"]])

export default __exports__